'use strict';

let _el;

const ContextMenuEl = {
    setElement(contextMenuEl) {
        _el = contextMenuEl;
    },

    show() {
        _el.show(...arguments);
    },

    close() {
        _el.close();
    }
};

module.exports = ContextMenuEl;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/ContextMenuCustom/ContextMenuEl.js
 **/